/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AlertConfigStatus {
  active = "active",
  archived = "archived",
  inactive = "inactive",
}

export enum AlertRunResultStatus {
  acked = "acked",
  flagged = "flagged",
  new = "new",
}

export enum AlertType {
  ad_fatigue = "ad_fatigue",
  anomaly_detection = "anomaly_detection",
  custom = "custom",
}

export enum AttemptToAddAccountManagerStatus {
  AlreadyManager = "AlreadyManager",
  HasError = "HasError",
  InvitationSent = "InvitationSent",
  SuccessfullyAdded = "SuccessfullyAdded",
}

export enum BenchmarkAttributionModelEnum {
  CLICKS_AND_VIEWS = "CLICKS_AND_VIEWS",
  CLICKS_ONLY = "CLICKS_ONLY",
}

export enum BenchmarkAttributionWindowEnum {
  NINETY_DAYS = "NINETY_DAYS",
  SIXTY_DAYS = "SIXTY_DAYS",
  THIRTY_DAYS = "THIRTY_DAYS",
}

export enum BenchmarkPlatformEnum {
  adwords = "adwords",
  facebook = "facebook",
  youtube = "youtube",
}

export enum BenchmarkTypeEnum {
  CAC = "CAC",
  ROAS = "ROAS",
}

export enum ConnectionType {
  integration_amazon = "integration_amazon",
  integration_amazon_seller = "integration_amazon_seller",
  integration_applovin = "integration_applovin",
  integration_attentive = "integration_attentive",
  integration_facebook_ads = "integration_facebook_ads",
  integration_google_adwords = "integration_google_adwords",
  integration_google_analytics = "integration_google_analytics",
  integration_klaviyo = "integration_klaviyo",
  integration_linkedin = "integration_linkedin",
  integration_microsoft = "integration_microsoft",
  integration_mntn = "integration_mntn",
  integration_pinterest = "integration_pinterest",
  integration_rakuten = "integration_rakuten",
  integration_refersion = "integration_refersion",
  integration_shopify = "integration_shopify",
  integration_snapchat = "integration_snapchat",
  integration_tatari = "integration_tatari",
  integration_tiktok = "integration_tiktok",
  integration_trade_desk = "integration_trade_desk",
  integration_twitter = "integration_twitter",
  integration_vibe = "integration_vibe",
}

export enum CreateBudgetRecommendationRunResultStatusGQLEnum {
  failed = "failed",
  finished = "finished",
  queued = "queued",
  started = "started",
}

export enum CreativeMetricType {
  base = "base",
  custom = "custom",
  facebook = "facebook",
  google = "google",
  pinterest = "pinterest",
  snapchat = "snapchat",
  tiktok = "tiktok",
  tradedesk = "tradedesk",
  twitter = "twitter",
  user_defined = "user_defined",
}

export enum CreativePlatformEnum {
  adwords = "adwords",
  applovin = "applovin",
  facebook = "facebook",
  pinterest = "pinterest",
  snapchat = "snapchat",
  tiktok = "tiktok",
  youtube = "youtube",
}

export enum CreativesFilterClauseTypeEnum {
  AND = "AND",
  OR = "OR",
}

export enum CreativesFilterClauseValueOperatorsEnum {
  equalsTo = "equalsTo",
  greaterThan = "greaterThan",
  greaterThanEqualTo = "greaterThanEqualTo",
  lessThan = "lessThan",
  lessThanOrEqualTo = "lessThanOrEqualTo",
}

export enum CreativesSortingOrder {
  asc = "asc",
  desc = "desc",
}

export enum CreativesStatusEnum {
  active = "active",
  inactive = "inactive",
}

export enum CreativesTypeEnum {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
}

export enum CustomerPathReportSorting {
  COUNT = "COUNT",
  REVENUE = "REVENUE",
  TRANSACTIONS = "TRANSACTIONS",
}

export enum DataExportFormat {
  CSV = "CSV",
}

export enum DataExportFrequency {
  DAILY = "DAILY",
  MONTHLY = "MONTHLY",
  WEEKLY = "WEEKLY",
}

export enum DataExportMethod {
  EXTERNAL_GCS_BUCKET = "EXTERNAL_GCS_BUCKET",
  EXTERNAL_S3_BUCKET = "EXTERNAL_S3_BUCKET",
  NORTHBEAM_GCS_BUCKET = "NORTHBEAM_GCS_BUCKET",
}

export enum DataExportType {
  ONE_OFF = "ONE_OFF",
  SCHEDULED = "SCHEDULED",
}

export enum DataExportV2DestinationFormat {
  CSV = "CSV",
}

export enum DataExportV2DestinationType {
  GCS = "GCS",
  S3 = "S3",
}

export enum DataExportV2PeriodType {
  LAST_12_MONTHS = "LAST_12_MONTHS",
  LAST_12_WEEKS = "LAST_12_WEEKS",
  LAST_14_DAYS = "LAST_14_DAYS",
  LAST_14_WEEKS = "LAST_14_WEEKS",
  LAST_26_WEEKS = "LAST_26_WEEKS",
  LAST_28_DAYS = "LAST_28_DAYS",
  LAST_28_WEEKS = "LAST_28_WEEKS",
  LAST_30_DAYS = "LAST_30_DAYS",
  LAST_3_DAYS = "LAST_3_DAYS",
  LAST_3_MONTHS = "LAST_3_MONTHS",
  LAST_3_WEEKS = "LAST_3_WEEKS",
  LAST_3_YEARS = "LAST_3_YEARS",
  LAST_4_WEEKS = "LAST_4_WEEKS",
  LAST_52_WEEKS = "LAST_52_WEEKS",
  LAST_5_YEARS = "LAST_5_YEARS",
  LAST_60_DAYS = "LAST_60_DAYS",
  LAST_6_MONTHS = "LAST_6_MONTHS",
  LAST_7_DAYS = "LAST_7_DAYS",
  LAST_7_WEEKS = "LAST_7_WEEKS",
  LAST_9_MONTHS = "LAST_9_MONTHS",
  LAST_MONTH = "LAST_MONTH",
  LAST_WEEK = "LAST_WEEK",
  LAST_YEAR = "LAST_YEAR",
  MONTH_TO_DATE = "MONTH_TO_DATE",
  THIS_MONTH = "THIS_MONTH",
  THIS_MONTH_AND_LAST_MONTH = "THIS_MONTH_AND_LAST_MONTH",
  THIS_WEEK = "THIS_WEEK",
  THIS_WEEK_AND_LAST_WEEK = "THIS_WEEK_AND_LAST_WEEK",
  TODAY = "TODAY",
  TODAY_AND_YESTERDAY = "TODAY_AND_YESTERDAY",
  YEAR_TO_DATE = "YEAR_TO_DATE",
  YESTERDAY = "YESTERDAY",
}

export enum DataExportV2ReportType {
  TOUCHPOINTS = "TOUCHPOINTS",
}

export enum DataExportV2TriggerSubType {
  TIME_BASED = "TIME_BASED",
}

export enum DataExportV2TriggerType {
  SCHEDULED = "SCHEDULED",
}

export enum MMMKpiType {
  first_time_customers = "first_time_customers",
  price_value = "price_value",
  transactions = "transactions",
}

/**
 * Possible states for one client MMM period
 */
export enum MMMState {
  adopting_mix = "adopting_mix",
  archived = "archived",
  blessing_model = "blessing_model",
  creating_settings = "creating_settings",
  draft = "draft",
  inputting_data = "inputting_data",
  preparing_mix = "preparing_mix",
  reviewing = "reviewing",
  tracking_mix = "tracking_mix",
}

export enum MetricType {
  decimal = "decimal",
  dollars = "dollars",
  integer = "integer",
  multiplier = "multiplier",
  percentage = "percentage",
}

export enum OnboardingStepType {
  ACCOUNT_MANAGERS = "ACCOUNT_MANAGERS",
  BASIC_DETAILS = "BASIC_DETAILS",
  CONFIGURE_PLATFORMS = "CONFIGURE_PLATFORMS",
  CURRENCY = "CURRENCY",
  DNS_SETUP = "DNS_SETUP",
  DOMAIN = "DOMAIN",
  INTRODUCTION = "INTRODUCTION",
  ORDERS_API = "ORDERS_API",
  PIXEL_PLACEMENT = "PIXEL_PLACEMENT",
  SPEND_API = "SPEND_API",
  VERIFY = "VERIFY",
}

export enum OrdersSortingField {
  date = "date",
  discountValue = "discountValue",
  numberOfOriginalItems = "numberOfOriginalItems",
  numberOfTouchpoints = "numberOfTouchpoints",
  orderValue = "orderValue",
  refundValue = "refundValue",
  shippingValue = "shippingValue",
  taxValue = "taxValue",
}

export enum OrdersSortingOrder {
  asc = "asc",
  desc = "desc",
}

export enum Partner {
  APPLOVIN = "APPLOVIN",
  META = "META",
  MNTN = "MNTN",
  PINTEREST = "PINTEREST",
  SNAPCHAT = "SNAPCHAT",
  TIKTOK = "TIKTOK",
}

export enum PartnerPermissionEnum {
  data_exports = "data_exports",
  data_impression_ingestion = "data_impression_ingestion",
}

export enum PathDateRangeFilterType {
  ENDED_WITHIN_DATE_RANGE = "ENDED_WITHIN_DATE_RANGE",
  INTERSECTS_DATE_RANGE = "INTERSECTS_DATE_RANGE",
  STARTED_AND_ENDED_WITHIN_DATE_RANGE = "STARTED_AND_ENDED_WITHIN_DATE_RANGE",
  STARTED_WITHIN_DATE_RANGE = "STARTED_WITHIN_DATE_RANGE",
}

export enum PixelTrackingEventType {
  CUSTOM_GOAL = "CUSTOM_GOAL",
  FPE_ERROR = "FPE_ERROR",
  IDENTIFY = "IDENTIFY",
  OTHER = "OTHER",
  PAGE_PING = "PAGE_PING",
  PAGE_VIEW = "PAGE_VIEW",
  PURCHASE_EVENT = "PURCHASE_EVENT",
}

export enum SalesTableTypeEnum {
  exclusive = "exclusive",
  inclusive = "inclusive",
  specific = "specific",
}

export enum SavedSearchMethod {
  comma = "comma",
  regex = "regex",
  text = "text",
}

export enum SavedSearchOperator {
  contains = "contains",
  does_not_contain = "does_not_contain",
  ends_with = "ends_with",
  is = "is",
  is_not = "is_not",
  starts_with = "starts_with",
}

export enum ScheduleTimeFrameFrequency {
  DAILY = "DAILY",
  MONTHLY = "MONTHLY",
  WEEKLY = "WEEKLY",
}

export enum ServerAPIServiceType {
  orders_api = "orders_api",
  spend_api = "spend_api",
}

export enum SortDirection {
  ASCENDING = "ASCENDING",
  DESCENDING = "DESCENDING",
}

export enum SubscriptionTypeEnum {
  FIRST_TIME = "FIRST_TIME",
  NONE = "NONE",
  OTHER = "OTHER",
  RETURNING = "RETURNING",
}

export enum TimeGranularityEnum {
  DAILY = "DAILY",
  HOURLY = "HOURLY",
  WEEKLY = "WEEKLY",
}

export enum ValueComparisonType {
  equalTo = "equalTo",
  greaterThan = "greaterThan",
  greaterThanOrEqualTo = "greaterThanOrEqualTo",
  lessThan = "lessThan",
  lessThanOrEqual = "lessThanOrEqual",
}

export enum WeekDay {
  Friday = "Friday",
  Monday = "Monday",
  Saturday = "Saturday",
  Sunday = "Sunday",
  Thursday = "Thursday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
}

export interface AttributionModelInput {
  attribution_model_name: string;
  state: boolean;
}

export interface AttributionWindowInput {
  attribution_window_days: string;
  state: boolean;
}

export interface BenchmarkTarget {
  attributionModel: BenchmarkAttributionModelEnum;
  attributionWindow: BenchmarkAttributionWindowEnum;
  benchmarkType: BenchmarkTypeEnum;
  customBenchmarks?: PlatformCACRoasBenchmarksInput[] | null;
  platform: BenchmarkPlatformEnum;
  target: number;
}

export interface ClientSettingFormShape {
  budget_high: string;
  budget_low: string;
  createBudgetRecommendationRunResults?: MMMCreateBudgetRecommendationRunResultsForm[] | null;
  cycle_id: string;
  desired_kpi_value?: number | null;
  end_date: string;
  id?: string | null;
  kpi_id?: string | null;
  kpi_v2_id?: string | null;
  max_cost_per_unit_kpi?: string | null;
  name: string;
  profit_value_per_unit_kpi?: string | null;
  reference_end_date?: string | null;
  reference_start_date?: string | null;
  spend_constraints: FormSpendConstraint[];
  start_date: string;
  target_spend: string;
}

export interface CreateAlertConfig {
  alertType: AlertType;
  description?: string | null;
  incidentTemplates: any;
  name: string;
  notificationSettings: any;
  runFrequency?: string | null;
  triggerConditions: any;
}

export interface CreativesFilterMetricClauseInput {
  customComposed: boolean;
  metric: CreativesMetricDefinitionInput;
  operator: CreativesFilterClauseValueOperatorsEnum;
  type: CreativeMetricType;
  value: number;
}

export interface CreativesMetricDefinitionInput {
  details?: CreativesMetricDetailsInput | null;
  id: string;
  metric: string;
}

export interface CreativesMetricDetailsInput {
  accountingMode?: string | null;
  am?: string | null;
  aw?: string | null;
  type?: string | null;
}

export interface CreativesMetricInput {
  customComposed: boolean;
  metric: CreativesMetricDefinitionInput;
  type: CreativeMetricType;
}

export interface CreativesMetricsFilterInput {
  clauseType: CreativesFilterClauseTypeEnum;
  metricClauses: CreativesFilterMetricClauseInput[];
}

export interface CreativesSortingInput {
  customComposed: boolean;
  metric: CreativesMetricDefinitionInput;
  order: CreativesSortingOrder;
  type: CreativeMetricType;
}

export interface CustomerPathFilterStage {
  campaignLabelFilters?: any[] | null;
  individualCampaignFilters?: IndividualCampaignFilterElement[] | null;
}

export interface CustomerReportDateRangeInput {
  endMonth: string;
  startMonth: string;
}

export interface DataExportBreakdownInput {
  key: string;
  position: number;
  values: string[];
}

export interface DataExportPerformanceMetricInput {
  accountingModes: string[];
  attributionModels: string[];
  attributionWindows: string[];
  id: string;
  label: string;
  position: number;
}

export interface DataExportPerformanceMetricsConfigInput {
  aggregateData: boolean;
  breakdowns: DataExportBreakdownInput[];
  defaultAccountingModes: string[];
  defaultAttributionModels: string[];
  defaultAttributionWindows: string[];
  exportAggregation: string;
  exportFileName: string;
  exportMethod: DataExportMethod;
  exportMethodDetails?: string | null;
  exportType: DataExportType;
  formats: DataExportFormat[];
  frequency?: DataExportFrequency | null;
  includeIds: boolean;
  includeKindAndPlatform: boolean;
  level: string;
  metrics: DataExportPerformanceMetricInput[];
  recipients?: string[] | null;
  removeZeroSpend: boolean;
  scheduleName?: string | null;
  scheduleTimeFrames?: DataExportScheduleTimeFrameInput[] | null;
  target: string;
  timeFrameEndDate?: string | null;
  timeFrameStartDate?: string | null;
  timeFrameType: string;
  timeGranularity: string;
}

export interface DataExportScheduleTimeFrameInput {
  day: string;
  time: string;
}

export interface DataExportV2DestinationInput {
  awsRole?: string | null;
  bucketName: string;
  exportFormat: DataExportV2DestinationFormat;
  fileName?: string | null;
  type: DataExportV2DestinationType;
}

export interface DataExportV2Input {
  destination: DataExportV2DestinationInput;
  reportData: DataExportV2ReportDataInput;
  trigger: DataExportV2TriggerInput;
}

export interface DataExportV2PeriodInput {
  type: DataExportV2PeriodType;
}

export interface DataExportV2ReportDataInput {
  period: DataExportV2PeriodInput;
  type: DataExportV2ReportType;
}

export interface DataExportV2TriggerInput {
  scheduleName: string;
  subType: DataExportV2TriggerSubType;
  timeFrames: ScheduleTimeFrameInput[];
  type: DataExportV2TriggerType;
}

export interface DataExportV2ValidateDestinationInput {
  awsRole?: string | null;
  bucketName: string;
  type: DataExportV2DestinationType;
}

export interface DateRangeInput {
  end: any;
  start: any;
}

export interface FormSpendConstraint {
  budget_high?: string | null;
  budget_low?: string | null;
  data_column_id?: string | null;
  data_column_v2_id?: string | null;
}

export interface IndividualCampaignFilterElement {
  adKey: any;
  name: string;
}

export interface LabelRuleV3Input {
  active?: boolean | null;
  isUsingSimpleUI?: boolean | null;
  labelRules?: (LabelRulesV3Input | null)[] | null;
  level?: string | null;
  name?: string | null;
}

export interface LabelRulesV3Input {
  _metadata?: any | null;
  active?: boolean | null;
  createdAt?: any | null;
  matcher?: any | null;
  name?: string | null;
  output?: string | null;
  priority?: number | null;
}

export interface LandingPageReportTableAdQueryInput {
  level: string;
  query: string;
}

export interface LandingPageReportTableMetricsFilterInput {
  id: string;
  operator: CreativesFilterClauseValueOperatorsEnum;
  value: number;
}

export interface LandingPageReportTableSortingInput {
  id: string;
  order: CreativesSortingOrder;
}

export interface MMMCreateBudgetRecommendationRunResultsForm {
  client_setting_id: string;
  id: string;
  modified: string;
  status: CreateBudgetRecommendationRunResultStatusGQLEnum;
}

export interface MMMForecastDataInput {
  data: any;
  date: string;
}

export interface MMMForecastInput {
  data: MMMForecastDataInput[];
  modelId?: number | null;
  modelPath: string;
}

export interface MMMGenerateBauBudgetInput {
  client_id: string;
  cycle_id: string;
  reference_end_date: string;
  reference_start_date: string;
  with_cache?: boolean | null;
}

export interface OrderTagSubscriptionAssociationInput {
  orderTag: string;
  subscriptionType: SubscriptionTypeEnum;
}

export interface OrdersFilterOptionsInput {
  adPlatforms?: string[] | null;
  adjustForReturns?: boolean | null;
  attributed?: string[] | null;
  customerId?: string | null;
  customerTags?: string[] | null;
  dateRange: DateRangeInput;
  discountCodes?: string[] | null;
  discountValue?: ValueFloatComparisonInput | null;
  ecommercePlatforms?: string[] | null;
  numberOfOriginalItems?: ValueIntComparisonInput | null;
  numberOfTouchpoints?: ValueIntComparisonInput | null;
  orderId?: string | null;
  orderNumber?: string | null;
  orderTags?: string[] | null;
  orderTypes?: string[] | null;
  orderValue?: ValueFloatComparisonInput | null;
  products?: string[] | null;
  refundValue?: ValueFloatComparisonInput | null;
  shippingValue?: ValueFloatComparisonInput | null;
  sourceName?: string[] | null;
  subscriptions?: SubscriptionTypeEnum[] | null;
  taxValue?: ValueFloatComparisonInput | null;
}

export interface OrdersGraphFilterOptionsInput {
  adPlatforms?: string[] | null;
  adjustForReturns?: boolean | null;
  attributed?: string[] | null;
  customerId?: string | null;
  customerTags?: string[] | null;
  discountCodes?: string[] | null;
  discountValue?: ValueFloatComparisonInput | null;
  ecommercePlatforms?: string[] | null;
  numberOfOriginalItems?: ValueIntComparisonInput | null;
  numberOfTouchpoints?: ValueIntComparisonInput | null;
  orderId?: string | null;
  orderNumber?: string | null;
  orderTags?: string[] | null;
  orderTypes?: string[] | null;
  orderValue?: ValueFloatComparisonInput | null;
  products?: string[] | null;
  refundValue?: ValueFloatComparisonInput | null;
  shippingValue?: ValueFloatComparisonInput | null;
  sourceName?: string[] | null;
  subscriptions?: SubscriptionTypeEnum[] | null;
  taxValue?: ValueFloatComparisonInput | null;
}

export interface OrdersSortingInput {
  sortingField: OrdersSortingField;
  sortingOrder: OrdersSortingOrder;
}

export interface PaginationInput {
  page: number;
  pageSize: number;
}

export interface PixelDateRangeInput {
  end: string;
  start: string;
}

export interface PixelTrackedOrdersInput {
  isPixelOnly: boolean;
  isPixelTrackable?: boolean | null;
  isPixelTracked?: boolean | null;
  limit?: number | null;
  offset: number;
  orderId?: string | null;
}

export interface PixelTrackingEventsFilterInput {
  dateRange: PixelDateRangeInput;
  typeIn?: (PixelTrackingEventType | null)[] | null;
}

export interface PlatformBenchmarkTargetInput {
  attributionModels: BenchmarkAttributionModelEnum[];
  attributionWindow: BenchmarkAttributionWindowEnum;
  benchmarkType: BenchmarkTypeEnum;
  platform: BenchmarkPlatformEnum;
  target: number;
}

export interface PlatformBenchmarksInput {
  blended: number;
  firstTime: number;
  returning: number;
}

export interface PlatformCACRoasBenchmarksInput {
  attributionModel: BenchmarkAttributionModelEnum;
  benchmarkType: BenchmarkTypeEnum;
  cac: PlatformBenchmarksInput;
  platform: BenchmarkPlatformEnum;
  roas: PlatformBenchmarksInput;
  target: number;
}

export interface ProductAnalyticsDateRangeInput {
  end: string;
  start: string;
}

export interface ProductAnalyticsFilterInput {
  accountingMode?: string | null;
  attributionModel?: string | null;
  attributionWindow?: string | null;
  dateRange: ProductAnalyticsDateRangeInput;
}

export interface ProductAnalyticsFilterWithPlatformCampaignAndAdInput {
  accountingMode?: string | null;
  adIds?: (string | null)[] | null;
  attributionModel?: string | null;
  attributionWindow?: string | null;
  campaignIds?: (string | null)[] | null;
  dateRange: ProductAnalyticsDateRangeInput;
  platformIds?: (string | null)[] | null;
}

export interface ProductAnalyticsFilterWithPlatformInput {
  accountingMode?: string | null;
  attributionModel?: string | null;
  attributionWindow?: string | null;
  dateRange: ProductAnalyticsDateRangeInput;
  platformIds?: (string | null)[] | null;
}

export interface ProductAnalyticsFilterWithPlatformInputAndCampaign {
  accountingMode?: string | null;
  attributionModel?: string | null;
  attributionWindow?: string | null;
  campaignIds?: (string | null)[] | null;
  dateRange: ProductAnalyticsDateRangeInput;
  platformIds?: (string | null)[] | null;
}

export interface ProductAnalyticsFilterWithProductIdsAndPlatformInput {
  accountingMode?: string | null;
  attributionModel?: string | null;
  attributionWindow?: string | null;
  dateRange: ProductAnalyticsDateRangeInput;
  platformIds?: (string | null)[] | null;
  productIds?: (string | null)[] | null;
}

export interface ProductAnalyticsFilterWithProductIdsInput {
  accountingMode?: string | null;
  attributionModel?: string | null;
  attributionWindow?: string | null;
  dateRange: ProductAnalyticsDateRangeInput;
  productIds?: (string | null)[] | null;
}

export interface ProductAnalyticsFilterWithProductIdsPlatformAndCampaignInput {
  accountingMode?: string | null;
  attributionModel?: string | null;
  attributionWindow?: string | null;
  campaignIds?: (string | null)[] | null;
  dateRange: ProductAnalyticsDateRangeInput;
  platformIds?: (string | null)[] | null;
  productIds?: (string | null)[] | null;
}

export interface SalesDateRangeInput {
  endDate: string;
  startDate: string;
}

export interface SalesMetricFilterInput {
  metricId: string;
  operator: string;
  value: number;
}

export interface SalesSortingInput {
  dimensionId?: string | null;
  metricId?: string | null;
  order: string;
}

export interface SalesTableReportSearchInput {
  method: SavedSearchMethod;
  operator?: SavedSearchOperator | null;
  query: string;
}

export interface SalesTableReportSortingInput {
  customComposed: boolean;
  metric: CreativesMetricDefinitionInput;
  order: CreativesSortingOrder;
  type: CreativeMetricType;
}

export interface SalesTableReportV3AdkeyFilter {
  adKey: string;
  dimensions: any;
}

export interface SalesTableReportV3BreakdownsFilterInput {
  breakdown: string;
  value: string;
}

export interface SalesTableReportV3FilterMetricClauseInput {
  customComposed: boolean;
  metric: CreativesMetricDefinitionInput;
  operator: CreativesFilterClauseValueOperatorsEnum;
  type: CreativeMetricType;
  value: number;
}

export interface SalesTableReportV3MetricsFilterInput {
  clauseType: CreativesFilterClauseTypeEnum;
  metricClauses: SalesTableReportV3FilterMetricClauseInput[];
}

export interface ScheduleTimeFrameInput {
  day?: number | null;
  frequency: ScheduleTimeFrameFrequency;
  time: string;
  weekDay?: WeekDay | null;
}

export interface SortInput {
  column: string;
  order: string;
}

export interface StringDateRange {
  endDate: string;
  startDate: string;
}

export interface UpsertCreativeSavedView {
  config: UpsertCreativeSavedViewConfig;
  id?: string | null;
  isDefault: boolean;
  name: string;
}

export interface UpsertCreativeSavedViewConfig {
  attributionModel: string;
  attributionWindow: string;
  breakdownFilters?: any[] | null;
  creativeType?: CreativesTypeEnum | null;
  dateRange: any;
  groupByAdName?: boolean | null;
  heroMetric: string;
  metricFilters?: CreativesMetricsFilterInput | null;
  metrics: string[];
  platforms: CreativePlatformEnum[];
  searchText?: string | null;
  sorting: any;
  sortingOrder: CreativesSortingOrder;
  status?: CreativesStatusEnum | null;
}

export interface ValueFloatComparisonInput {
  comparisonOperator: ValueComparisonType;
  value: number;
}

export interface ValueIntComparisonInput {
  comparisonOperator: ValueComparisonType;
  value: number;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
